import { combineReducers } from 'redux';
import userReducer from './user';
import uiReducer from './UI';
import searchReducer from './search';
import groupsReducer from './groups';
import ChatReducer from './chat';
import reviewsReducer from './reviews';

const rootReducer = combineReducers({
  user: userReducer,
  ui: uiReducer,
  search: searchReducer,
  groups: groupsReducer,
  chat: ChatReducer,
  reviews: reviewsReducer
});

export default rootReducer;